/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ProfileStatus {
  Active = "Active",
  Alum = "Alum",
  AlumDNR = "Alum DNR",
  Beach = "Beach",
  Certifying = "Certifying",
  Idle = "Idle",
  InDiligence = "In Diligence",
  NewLead = "New Lead",
  PendingActive = "Pending Active",
  PendingAlum = "Pending Alum",
  PendingAlumDNR = "Pending Alum DNR",
  PendingBeach = "Pending Beach",
  Reservoir = "Reservoir",
  Rejected = "Rejected",
  Waitlist = "Waitlist",
}

export const ProfileStatusDisplay: Record<ProfileStatus, string> = {
  [ProfileStatus.Active]: "Active",
  [ProfileStatus.Alum]: "Alum",
  [ProfileStatus.AlumDNR]: "Alum DNR",
  [ProfileStatus.Beach]: "Beach",
  [ProfileStatus.Certifying]: "Certifying",
  [ProfileStatus.Idle]: "Idle",
  [ProfileStatus.InDiligence]: "In Diligence",
  [ProfileStatus.NewLead]: "New Lead",
  [ProfileStatus.PendingActive]: "Pending Active",
  [ProfileStatus.PendingAlum]: "Pending Alum",
  [ProfileStatus.PendingAlumDNR]: "Pending Alum DNR",
  [ProfileStatus.PendingBeach]: "Pending Beach",
  [ProfileStatus.Reservoir]: "Reservoir",
  [ProfileStatus.Rejected]: "Rejected",
  [ProfileStatus.Waitlist]: "Waitlist",
};
